import React from 'react';
import classNames from 'classnames';
import styles from './Section.module.scss';

function Icon({ icon, IconComponent }) {
  if (!icon && !IconComponent) {
    return null;
  }

  return (
    <span className={styles.sectionTitleIconContainer}>
      {IconComponent && !icon && <IconComponent className={styles.sectionTitleIcon} />}
      {icon && !IconComponent && <img className={styles.sectionTitleIcon} src={icon} />}
    </span>
  );
}

function Title({
  as: Component = 'span',
  children = null,
  spaced = false,
  underline = false,
  icon = null,
  IconComponent = null,
  loading = false,
  className = null,
  listItem = false,
  ...props
}: any) {
  className = classNames(styles.sectionTitle, className, {
    [styles.sectionTitleSpaced]: spaced,
    [styles.sectionTitleUnderlined]: underline,
    [styles.sectionTitleListItem]: listItem,
  });

  return (
    <span className={className}>
      <Icon icon={icon} IconComponent={IconComponent} />
      <Component {...props}>{children}</Component>
    </span>
  );
}

function Description({ as: Component = 'span', children = null, className = null, ...props }: any) {
  className = classNames(styles.sectionDescription, className);

  return (
    <div className={className}>
      <Component {...props}>{children}</Component>
    </div>
  );
}

export default function Section({ className = null, children = null, htmlRef = null, ...props }) {
  return (
    <div {...props} className={classNames(styles.section, className)} ref={htmlRef}>
      {children}
    </div>
  );
}

Section.Title = Title;
Section.Description = Description;
